//@ts-nocheck
import { useState } from 'react';
import type { NextPage } from 'next';
import Link from 'next/link';
import Image from 'next/image';
import { BailetsBlock } from '../../ModalCopy.styles';
import { CloseVideoIcon, LogoMartins } from '@assets/svgs';
import { CWriting } from '@data/copywriting';
import oscar1 from '@assets/oscar1.jpg';
import oscar2 from '@assets/oscar2.jpg';
import oscar3 from '@assets/oscar3.jpg';
import marccain1 from '@assets/marccain1.jpg';
import marccain2 from '@assets/marccain2.jpg';
import carolina1 from '@assets/carolina1.jpg';
import carolina2 from '@assets/carolina2.jpg';
import carolina3 from '@assets/carolina3.jpg';
import ward1 from '@assets/ward1.jpg';
import ward2 from '@assets/ward2.jpg';
import ward3 from '@assets/ward3.jpg';
import ward4 from '@assets/ward4.jpg';
import tony2 from '@assets/tony_2.jpg';
import tony3 from '@assets/tony_3.jpg';
import elisabetta1 from '@assets/elisabetta_1.jpg';
import elisabetta2 from '@assets/elisabetta_2.jpg';

type CollectionProps = {
  isClosed?: () => void;
  showImg?: boolean | string;
  showMedia?: boolean | string;
};

export const CollectionSS25 = ({
  isClosed,
  showImg,
  showMedia
}: CollectionProps) => {
  return (
    <>
      <BailetsBlock>
        <Link className="closeIcon_A" href={'/'}>
          {' '}
          <CloseVideoIcon animation="closeIcon" color="#000" />
        </Link>
        <LogoMartins
          width={70}
          height={65}
          color="rgba(0,0,0,0.5)"
          animation="mansion"
        />

        <h3>MARTIN'S FASHION</h3>
        <span style={{ marginBottom: '25px' }}>We are Fashion writers</span>
        {showImg && <Image src={showImg} width={1480} height={825} alt="" />}
        <Link style={{ textDecoration: 'underline' }} href={'/Breaking'}>
          Watch More Collection Stories
        </Link>
        <Link
          style={{ textDecoration: 'underline', marginTop: '20px' }}
          href={'http://fass-hion.jorgedd.com/Story/'}
        >
          Visit FASS-HION Magazine
        </Link>
      </BailetsBlock>
      <BailetsBlock>
        <h3>FALL/WINTER 25 - 26</h3>
      </BailetsBlock>

      <BailetsBlock>
        <h3>ELISABETTA FRANCHI</h3>
        <span style={{ marginBottom: '25px' }}>Fall/Winter 25 - 26</span>
        <video
          controlsList="nodownload"
          controls={true}
          playsInline
          muted
          autoPlay
          loop
        >
          <source
            src={'/media/Elisabetta_Franchi_FW25_26.mp4'}
            type="video/mp4"
          />
        </video>
        <h3 style={{ marginTop: '25px' }}>A Tribute to Empowered</h3>
        <h3>Gentleness and Prestige!</h3>
        <br />
        <br />
        <p style={{ width: '100%' }}>Design Aesthetic: A Play on Opposites</p>
        <p style={{ width: '100%' }}>
          The eagerly awaited Elisabetta Franchi Fall-Winter 2025 collection was
          unveiled to the world on 28 February 2025, in the magnificent setting
          of Palazzo Acerbi during Milan Fashion Week. This elegant 17th-century
          venue, renowned for its architectural grandeur and ties to the
          audacious Marquis Ludovico Acerbi, provided the perfect backdrop for a
          collection that celebrates unapologetic femininity, elegance, and
          empowerment.
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>The Vision Behind the Collection</b>
        </p>
        <p style={{ width: '100%' }}>
          Creative Director Elisabetta Franchi described the collection as a
          tribute to women who are unafraid to express themselves and embrace
          their sensuality with confidence and determination. She highlights
          that every piece in the collection tells the story of a woman who
          challenges conventions gracefully while maintaining her power. The
          choice of Palazzo Acerbi as the venue reflects the collection's themes
          of opulence, audacity, and strength.
          <br />
          <br /> “This collection is a tribute to the strength and freedom of
          women who are unafraid to express themselves,” Franchi stated.
          “Through its rooms, I wanted to bring to life, femininity that is
          elegant and disciplined, assertive yet provocative.” She said.
        </p>
        <br/>
        <Image src={elisabetta1} width={1900} height={2525} alt="Ward 4" />
        <br />
        <p style={{ width: '100%' }}>
          <b>Venue: Palazzo Acerbi</b>
        </p>
        <p style={{ width: '100%' }}>
          Choosing Palazzo Acerbi as the venue was both symbolic and strategic.
          This 17th-century building, which was once home to Marquis Ludovico
          Acerbi, is famous for its rich history and association with opulence.
          The palazzo's beautiful rooms, with their detailed frescoes and
          Baroque features, provided the perfect setting for a collection that
          celebrates bold femininity. The glory of the setting made the themes
          of the collection even more powerful and created an experience that
          the audience could really get into.
        </p>
        <br/>
        <Image src={elisabetta2} width={1900} height={2525} alt="Ward 4" />
        <br />
        <p style={{ width: '100%' }}>
          <b>Reception and Impact</b>
        </p>
        <p style={{ width: '100%' }}>
          The collection was met with resounding acclaim for its bold
          reinterpretation of power dressing. By skilfully blending structured
          tailoring with sensual elements, Elisabetta Franchi introduced a
          thrillingly fresh perspective on contemporary femininity. The
          strategic use of textures and the cohesive colour palette contributed
          to a collection that is both daring and sophisticated. The choice of
          Palazzo Acerbi was a masterstroke, not only showcasing the brand's
          deep Italian roots but also amplifying the collection's themes of
          unbridled opulence and audacity.<br/><br/> Elisabetta Franchi's 2025
          autumn/winter fashion show celebrated women's strength, freedom and
          sexiness. The designs were very carefully created and presented in a
          way that went against traditional ideas of fashion, while showing that
          the Elisabetta Franchi brand is still dedicated to making women feel
          strong. The combination of historical grandeur and modern fashion made
          the show memorable and powerful. It also showed that Elisabetta
          Franchi is one of the most important names in modern fashion.<br/><br/>
          Femininity is your superpower!
        </p>
      </BailetsBlock>

      <BailetsBlock>
        <h3>TONY WARD</h3>
        <span style={{ marginBottom: '25px' }}>Fall/Winter 25 - 26</span>
        <video
          controlsList="nodownload"
          controls={true}
          playsInline
          muted
          autoPlay
          loop
        >
          <source src={'/media/tony_ward_FW_25-26.mp4'} type="video/mp4" />
        </video>
        <h3 style={{ marginTop: '25px' }}>Bold yet unforgettable,</h3>
        <h3>Lavish and splendid!</h3>
        <br />
        <br />
        <p style={{ width: '100%' }}>A Peaceful Blend of Nature and Shape.</p>
        <p style={{ width: '100%' }}>
          You’ll be stunned and amazed! The latest ready-to-wear collection by
          Tony Ward for fall/winter 2025-26 is here! This impressive line
          celebrates nature's beauty, attractively translated into fashion. “Of
          Silk and Steel" is a masterpiece, capturing the essence of the desert
          at dusk and showcasing Ward's unbelievable talent for agnating
          elegance with practicality. The collection's thoughtful design,
          innovative use of colour and texture, and unwavering commitment to
          craftsmanship make it a true standout. Ward's latest offering is a
          fresh view on ready-to-wear fashion that is both ageless and
          contemporary.
        </p>
        <br />
        <Image src={tony3} width={1900} height={2525} alt="Ward 4" />
        <p style={{ width: '100%' }}>
          The painting "Of Silk and Steel" shows a journey through the desert.
          It starts with the warm colours of the sandy dunes and ends with the
          cool colours of the sky at night. Ward is interested in contrast. He
          compares the roughness of the desert with the softness of the setting
          sun. This creates a feeling of adventure and calm.
        </p>
        <p style={{ width: '100%' }}>
          The painting "Of Silk and Steel" shows a journey through the desert.
          It starts with the warm colours of the sandy dunes and ends with the
          cool colours of the sky at night. Ward is interested in contrast. He
          compares the roughness of the desert with the softness of the setting
          sun. This creates a feeling of adventure and calm.
        </p>
        <Image src={tony2} width={1900} height={2525} alt="Ward 4" />
        <p style={{ width: '100%' }}>
          The colours in the collection show the many sides of the desert's
          beauty. Warm colours like Rubin red and pink quartz show the richness
          of the desert sands, while cooler colours such as blue serenity and
          water green show the calming effect of the approaching night. This
          careful choice of colours not only reflects the natural environment
          but also makes each outfit look more interesting.
        </p>
        <p style={{ width: '100%' }}>
          Ward's experience in architecture is evident in the collection's
          designs. The outfits combine sculptural shapes that fit around the
          waist with comfortable cargo silk trousers, making traditional safari
          clothing look more modern. Sheer shirts add a feminine touch, while
          large hats offer both style and practicality. The kimono-style
          midi-dresses with big pockets combine functionality with elegance,
          reflecting the modern explorer's spirit.
        </p>
        <p style={{ width: '100%' }}></p>
      </BailetsBlock>

      <BailetsBlock>
        <h3>OSCAR DE LA RENTA</h3>
        <span style={{ marginBottom: '25px' }}>Fall 2025</span>
        <video
          controlsList="nodownload"
          controls={true}
          playsInline
          muted
          autoPlay
          loop
        >
          <source
            src={'/media/oscar_de_la_renta_FW25_26.mp4'}
            type="video/mp4"
          />
        </video>
        <h3 style={{ marginTop: '25px' }}>A Blossoming Tribute to</h3>
        <h3>Immortal Elegance and Charm.</h3>
        <br />
        <br />
        <p style={{ width: '100%' }}>New York Fashion Week.</p>
        <p style={{ width: '100%' }}>
          The Oscar de la Renta Fall 2025 runway show, held on 12 February 2025
          during New York Fashion Week, was nothing short of spectacular! A
          breathtaking display of elegance, craftsmanship and natural beauty, it
          was a true celebration of fashion. The show, presented by Co-Creative
          Directors Laura Kim and Fernando Garcia, paid homage to the tree
          peony. They transformed the boutique's newly opened Madison Avenue
          Flagship into a sophisticated New York townhouse for the occasion,
          making it the perfect backdrop for this stunning collection.
        </p>
        <p style={{ width: '100%' }}>
          At the heart of the collection was the stunning tree peony, a symbol
          of wealth and elegance. This beautiful motif was showcased in a
          variety of ensembles, from eye-catching prints to intricate threadwork
          appliqués. The designers' meticulous attention to detail ensured that
          the peony's presence was both subtle and striking, adding depth and
          texture to the garments in a way that was simply breathtaking.
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>Palette and Patterns: Elegance for Autumn</b>
        </p>
        <p style={{ width: '100%' }}>
          The colour palette was absolutely perfect for the season, with its
          rich shades of cedar, blue quartz, and chrysanthemum. These gorgeous
          hues were enlivened by vibrant pops of citrine, creating a dynamic and
          truly eye-catching visual experience. The innovative patterns, such as
          the bold cowhide animal print and the wavy, textured plaid, were a
          real highlight, adorning outerwear and tailored silhouettes. They
          offered a fresh perspective on classic designs that will surely be a
          hit this season!
        </p>
        <p style={{ width: '100%' }}>
          Embellishments played a pivotal role in elevating the collection's
          sophistication, taking it to new heights. Crystal clusters and
          geometric sequin embroideries adorned key pieces, including a
          strapless black velvet cupcake dress and an ice-blue strapless column
          gown with fringe detailing.Peony embellishments appeared throughout,
          from tailored cotton poplin and silk twill dresses to printed jacquard
          coats and peony lace guipure blouses. The showstopper of the entire
          collection was undoubtedly the mirror mosaic embroidered mini dress, a
          true testament to the brand's unwavering dedication to meticulous
          craftsmanship.
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>A Harmonious Blend of Tradition and Modernity</b>
        </p>
        <p style={{ width: '100%' }}>
          The evening gowns were, without a doubt, the showstoppers of the
          collection, but that wasn't all! The range also included a selection
          of more versatile pieces, including tailored cotton poplin and silk
          twill dresses, printed jacquard coats and peony lace guipure blouses.
          This demonstrated the brand's ability to create beautiful, wearable
          clothing for all occasions.A particularly noteworthy inclusion was a
          denim set featuring thread work peony appliqué, showcasing the
          designers' skill in elevating casual fabrics to luxury status. This
          blend of high and low, casual and formal, is a hallmark of
          contemporary luxury fashion and demonstrates Oscar de la Renta's
          incredible ability to evolve with the times while maintaining its core
          identity.
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>Versatility and Wearability</b>
        </p>
        <p style={{ width: '100%' }}>
          The Oscar de la Renta Fall 2025 runway show was a celebration of the
          brand's incredible heritage and its forward-looking vision. Through
          the inspired use of the striking tree peony motif, a rich and vibrant
          color palette, and meticulous craftsmanship, Laura Kim and Fernando
          Garcia presented a truly remarkable collection that honoured tradition
          while embracing contemporary aesthetics. The intimate setting,
          thoughtful beauty choices, and distinguished guests all contributed to
          an unforgettable showcase of fashion excellence.
        </p>
      </BailetsBlock>

      <BailetsBlock>
        <h3>EMPORIO ARMANI</h3>
        <span style={{ marginBottom: '25px' }}>Fall/Winter 2025 - 2026</span>
        <video
          controlsList="nodownload"
          controls={true}
          playsInline
          muted
          autoPlay
          loop
        >
          <source src={'/media/armani_FW_25_26.mp4'} type="video/mp4" />
        </video>
        <h3 style={{ marginTop: '25px' }}>Timeless at the Age of 90</h3>
        <h3>The Attraction of playing Cards.</h3>
        <br />
        <br />
        <p style={{ width: '100%' }}>Milan Fashion Week.</p>
        <p style={{ width: '100%' }}>
          Emporio Armani's latest and most stunning women's collection is
          finally here! Featured at Milan Fashion Week, the Fall/Winter
          2025-2026 collection is a fusion of the brand's timeless elegance and
          contemporary chic like never before. Titled "Seductive," the
          collection is the pinnacle of Giorgio Armani's unapologetic love for
          youthful sophistication, with rich textures and innovative designs
          that will surely make heads turn.
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>A Playful Motif</b>
        </p>
        <p style={{ width: '100%' }}>
          At the heart of the collection was the absolutely delightful
          incorporation of playing card motifs, symbolising themes of play and
          fun. The sequined bodices, belts and jacket pockets adorned with card
          symbols added a playful yet sophisticated touch to the ensembles,
          which was astonishing and phenomenal. Heart-shaped tops,
          diamond-shaped belt buckles and jewellery inspired by clubs and spades
          further emphasised this motif, infusing the collection with a sense of
          lighthearted elegance that was simply captivating.
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>Vibration and the vintage magic</b>
        </p>
        <p style={{ width: '100%' }}>
          Simply glamorous and immortal!
          <br />
          <br />
          The collection was a standout, with vibrant mix of textures and
          fabrics. Velvet three-piece suits, paired with delicate watch chains,
          oozed vintage charm. Fine ribbed lurex knitwear added a touch of
          subtle shimmer, while luxurious corduroy pants elegantly pooled around
          robust lug-sole shoes, perfectly balancing comfort and style.
        </p>
      </BailetsBlock>

      <BailetsBlock>
        <h3>SPRING/SUMMER 25</h3>
      </BailetsBlock>
      <BailetsBlock>
        <h3>TONY WARD</h3>
        <span style={{ marginBottom: '25px' }}>Spring/Summer 2025</span>
        <video
          controlsList="nodownload"
          controls={true}
          playsInline
          muted
          autoPlay
          loop
        >
          <source src={'/media/tonyward_SS_25.mp4'} type="video/mp4" />
        </video>
        <h3 style={{ marginTop: '25px' }}>A celebration of Glamour</h3>
        <h3>Perfection and Modernity.</h3>
        <br />
        <br />
        <p style={{ width: '100%' }}>
          Delighted creativity, skills and originality were displayed at the
          Paris “Haute Couture” Fashion Week. Highly requested by his fans, the
          amazing Tony Ward revealed his compilation, “Twilight Reverie” on
          January 30, 2025. This collection is a beautiful symphony of flowing
          motifs, elaborate embroidery, and ethereal forms that defy the
          boundaries of traditional haute couture. This exquisite collection is
          a monument to the Lebanese-Italian designer’s unmatched mastery of
          beauty The collection itself was astonishing in how deeply it captured
          the American glam fashion era and served modernity.
        </p>
        <p style={{ width: '100%' }}>
          Get ready to witness an extraordinary runway never seen before. The
          Ward Spring/Summer 2025 Couture collection pays subtraction to both
          cinematic icons and global sophistication fully embodying Lebanese
          wonder and Old Hollywood fashion. The location, a castle in Lebanon
          owned by an American Lebanese, busting with the spirit of Los Angeles,
          was fantastic in itself. As elusive as its designs, the caption of the
          collection was an ode to California style and the Mediterranean
          heritage.
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>A Vision of Twilight Reverie</b>
        </p>
        <br />
        <Image src={ward1} width={1900} height={2525} alt="Ward 1" />
        <p style={{ width: '100%' }}>
          Tony Ward Spring-Summer 2025 drew inspiration from this magic moment:
          passing from day to night, full of mystery and romance when everything
          is allowed. "Twilight Reverie" captures in fabric, texture, and
          silhouette the poetic beauty of that instant, dripping with the soft
          glow of dusk and the shimmering aura of twilight.
        </p>
        <p style={{ width: '100%' }}>
          Pastel hues of the last light of day into evening opened the show,
          with soft shades of blush, powder blue, and lavender dominating the
          collection. Gradually, these subtle tones give way to deep midnight
          blues, shimmering silvers, and celestial blacks to symbolise time
          passing. Every outfit seemed to tell a tale of the transformation of
          light dissolving into shadow and dreams merging into reality.
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>A Celebration of Femininity and Craftsmanship</b>
        </p>
        <p style={{ width: '100%' }}>
          Renowned for perfection in workmanship. In this collection, one could
          see his devotion to detail. All these gowns displayed a perfect blend
          of traditional techniques of couture and current trends.
          Embellishments, a staple in all of Ward’s collections, took a heavenly
          theme, with constellations, moonlit waves, and burning starbursts
          stitched in delicate tulle, chiffon, and organza.
        </p>
        <p style={{ width: '100%' }}>
          The silhouettes ranged from cinched, bodice-shaped ones and floating,
          floor-grazing ones moving in poetic motion to one with a frock and a
          froth of crystalline-beaded lace, a fall of stardust, and a bold
          asymmetrical drape with an aura of beauty and fortitude at once.
        </p>
        <p style={{ width: '100%' }}>
          Other than gowns, even a modern reinterpretation of cutting-edge
          couture took shape in the collection. Chiselled jackets, custom-fit
          jumpsuits, and futuristic capes imparted a dash of power dressing,
          addressed to the workingwoman of today who seeks beauty and confidence
          in her attire.
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>A Show Steeped in Atmosphere and Grandeur</b>
        </p>
        <br />
        <Image src={ward2} width={1900} height={2525} alt="Ward 2" />
        <Image src={ward3} width={1900} height={2525} alt="Ward 3" />
        <p style={{ width: '100%' }}>
          The runway became a dreamland, softly lit and changing ribbon in peace
          with the sunset colours. A real orchestra played a hypnotic tune,
          rounding out the dreamlike atmosphere of "Twilight Reverie." There
          moved down the runway an aura of heavenly beauty with each model,
          radiating dreamlike beauty of Ward's creation — heavenly beauty.
        </p>
        <p style={{ width: '100%' }}>
          A-list celebrities, style followers, and high fashion devotees filled
          out the first row, imparting an aura of grandeur to the occasion. On
          the other hand, worldwide fashion icons, Hollywood personalities, and
          royalties, all of whom longed to see Ward’s new works in detail.
          Onlookers gloated in wonder at each creation like a skillfully
          designed work of art in motion.
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>A Sustainable Future in Couture</b>
        </p>
        <p style={{ width: '100%' }}>
          Tony Ward continues to cover a desire for beauty and a concern for
          sustainability in his collections. "Twilight Reverie included
          environmentally responsible materials such as biodegradable silk,
          recycled sequins, and vegetal dye, reflecting a less
          planet-devastating future for fashion.
        </p>
        <p style={{ width: '100%' }}>
          Ethical working practice mattered most for Ward of working with
          traditional embroiderers and manipulators of cloth, with regard for
          each work of beauty not simply an expression but a tribute to mastery
          skill and sustainability.
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>The Grand Finale: A Statement of Hope and Beauty</b>
        </p>
        <br />
        <Image src={ward4} width={1900} height={2525} alt="Ward 4" />
        <p style={{ width: '100%' }}>
          The show reached its heart-thudding conclusion with a
          thousand-bejewelled, regal ballgown, a sky filled with moving
          constellations. As it ornated down the runway, a hypnotic flourish to
          an already magical collection glinted. On its feet, rose a thunderous
          ovation in a room filled with humans, a tribute to Tony Ward’s mastery
          and skill.
        </p>
        <p style={{ width: '100%' }}>
          Tony Ward’s Spring/summer 2025 collection is a poetic tapestry of
          light, time, and feminine beauty. "Twilight Reverie" took its guests
          to a dreamland in which heavenly fantasy and couture merged, a
          demonstration, yet again, that The designer is a magician in the
          narrative in cloth and form.
        </p>
        <p style={{ width: '100%' }}>
          The collection re-established itself at the height of haute couture, a
          reminder to the world that fashion has nothing to do with clothes, but
          an artwork that touches, tells, and inspires.
        </p>
        <p style={{ width: '100%' }}>
          And when that first bow was taken, one could have no doubt: a moment
          of real sorcery in couture had been experienced in a room full of
          humans.
        </p>
      </BailetsBlock>
      <BailetsBlock>
        <h3>CAROLINA HERRERA</h3>
        <span style={{ marginBottom: '25px' }}>Spring/Summer 2025</span>
        <video
          controlsList="nodownload"
          controls={true}
          playsInline
          muted
          autoPlay
          loop
        >
          <source
            src={'/media/carolinaherrera_resort_25.mp4'}
            type="video/mp4"
          />
        </video>
        <h3 style={{ marginTop: '25px' }}>
          A Festivity of Elegance and Femininity
        </h3>
        <h3>A Sophisticated Extravagance Resort.</h3>
        <br />
        <br />
        <p style={{ width: '100%' }}>
          Carolina Herrera Resort 2025 collection celebrates elegance,
          femininity, and freedom. Presented against a sunlight backdrop, it
          captures the spirit of richness while paying homage to Herrera’s
          signature: perfect harmony between classic and modern facilities.
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>The Venue: A Tropical Haven of Inspiration</b>
        </p>
        <p style={{ width: '100%' }}>
          The runway took place in a beautiful coastal hideaway. It was set up
          outside, with the delighted ocean sound in the background. The show
          made people feel like they were on holiday, with a feeling of
          relaxation. Guests were seated under palm trees, and the sound of
          waves went well with the bright colours and shapes of the clothing
          shown on the runway.
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>The Collection:</b>
        </p>
        <br />
        <Image src={carolina1} width={1900} height={2525} alt="Carolina 1" />
        <p style={{ width: '100%' }}>
          <b>Flowing Dresses:</b> Billowy gowns and maxi dresses in lightweight
          fabrics like chiffon and silk captured the freedom and movement of the
          resort lifestyle. Many pieces featured asymmetrical hemlines and
          daring plunging necklines, emphasising a carefree yet polished appeal.
        </p>
        <p style={{ width: '100%' }}>
          <b>Floral Motifs:</b> Hand-painted floral prints were a recurring
          theme, reflecting Herrera’s signature romantic style. Oversized roses
          and wildflowers added a touch of whimsy to structured dresses and
          separates.
        </p>
        <p style={{ width: '100%' }}>
          <b>Tailored Ensembles:</b> Power suits were given a summery twist with
          cropped jackets, wide-leg trousers, and unexpected colours. Their
          combination of structure and ease made them versatile for day and
          evening wear.
        </p>
        <p style={{ width: '100%' }}>
          <b>Sheer Layers:</b> Soft, translucent fabrics created depth and
          texture, with sheer overlays enhancing the allure of several evening
          looks. These designs exuded elegance while keeping the collection
          playful and light.
        </p>
        <p style={{ width: '100%' }}>
          <b>Statement Accessories:</b> Oversized straw hats, colourful beaded
          earrings, and embellished sandals tied each look together, adding an
          extra layer of resort-ready charm.
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>A Modern and young Vacation dresser</b>
        </p>
        <br />
        <Image src={carolina2} width={1900} height={2525} alt="Carolina 2" />
        <p style={{ width: '100%' }}>
          Wes Gordon described the Resort 2025 collection as “an invitation to
          dream.” He drew inspiration from travellers who blend comfort and
          sophistication, deepening garments that transition effortlessly from
          day to night. The collection was designed for women who embrace bold
          femininity and wish to make a statement, whether strolling along the
          coast or attending a glamorous soirée.
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>Celebrity Front Row and Star Power</b>
        </p>
        <p style={{ width: '100%' }}>
          The front row was full of famous people. Celebrities like Zendaya,
          Anne Hathaway and Emily Blunt wore clothes from Herrera's latest
          collection. They all looked amazing and the audience was enthusiastic.
          Herrera is still one of the most important fashion brands inspiring
          personalities around the globe.
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>A Tribute to Carolina Herrera’s Legacy</b>
        </p>
        <br />
        <Image src={carolina3} width={1900} height={2525} alt="Carolina 3" />
        <p style={{ width: '100%' }}>
          The runway show was extraordinary. It mixed modern styles with classic
          charm. It showed that the brand can stay popular while remembering its
          history of making practical clothes. The bright colours and romantic
          shapes made the collection stand out, and it was a real highlight of
          the resort season.
        </p>
        <p style={{ width: '100%' }}>
          As the sun set over the runway and the models walked for the last
          time, it was clear that Carolina Herrera's Resort 2025 collection
          would be a big inspiration for people's wardrobes and holidays. It
          would have a long-lasting impact on the fashion world.{' '}
        </p>
        <p style={{ width: '100%' }}>Stay Inspired!</p>
      </BailetsBlock>
      <BailetsBlock>
        <h3>OSCAR DE LA RENTA</h3>
        <span style={{ marginBottom: '25px' }}>Pre - Spring 2025</span>
        <video
          controlsList="nodownload"
          controls={true}
          playsInline
          muted
          autoPlay
          loop
        >
          <source src={'/media/oscardelerenta.mp4'} type="video/mp4" />
        </video>
        <h3 style={{ marginTop: '25px' }}>The Garden of Dreams</h3>
        <h3>And a Legacy of Elegance.</h3>
        <br />
        <br />
        <p style={{ width: '100%' }}>
          <b>
            And fashion is the garden masterpiece! Arguments are not enough to
            express delicacy.
          </b>
          <br />
          <br />
          Oscar de la Renta’s Pre-Spring 2025 collection transported fashion
          enthusiasts into an enchanting world where nature’s wild beauty met
          modern elegance. Co-creative Directors Laura Kim and Fernando Garcia
          presented their breathtaking designs in New York’s lush botanical
          gardens, a setting that perfectly complemented the collection’s floral
          and natural inspirations.
        </p>
        <p style={{ width: '100%' }}>
          “Here extravagance is the word that spreads vibration” -
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>The Stars affair</b>
        </p>
        <p style={{ width: '100%' }}>
          The fashion show was a party of artistry and flair. Celebrities and
          fashion images corroded land flowers to watch this astonishing show.
          Zendaya, the one who is legendary for her insolent still stylish
          fashion selections, dazed in a personalised gown from the group that
          integrated audacity and girlishness. Gigi Hadid picked a
          snakeskin-print coat for rain that flaunted her style as a flashy act
          by booklet covers.{' '}
        </p>
        <p style={{ width: '100%' }}>
          Meanwhile, Emma Watson chose a bright poplin dress that showed her
          commitment to the environment. Timothée Chalamet created an impact,
          tiring a smart suit accompanying delicate flower decoration.
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>A Perfectly Arranged Setting</b>
        </p>
        <br />
        <Image src={oscar1} width={1900} height={2525} alt="Oscar 1" />
        <p style={{ width: '100%' }}>
          Choosing New York's Botanical Gardens as the scene was an excellent
          plan. The green plants and brilliant flowers made the background look
          legitimately nice and amounted to the plans behind the accumulation.
          As models paraded the catwalk, the Art Nouveau and Renaissance-style
          construction made the occurrence feel more certain, which many were
          amazed by.
        </p>
        <p style={{ width: '100%' }}>
          The way the show was organised made it even more special. The soft,
          shimmering light that created the designs, from the delicate tapestry
          to the bright silver fabrics, was accompanied by the gentle sound of
          live classical music.
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>Craftsmanship and Innovation</b>
        </p>
        <br />
        <Image src={oscar2} width={1900} height={2525} alt="Oscar 2" />
        <Image src={oscar3} width={1900} height={2525} alt="Oscar 3" />
        <p style={{ width: '100%' }}>
          The Pre-Spring 2025 collection was all about quality and new ideas.
          The gold metal organza (a thin, sheer fabric) with orchid patterns
          showed the brand's dedication to pushing the boundaries of textile
          design. The hand-threaded guipure lace also showed the small details
          that are a hallmark of Oscar de la Renta.
        </p>
        <p style={{ width: '100%' }}>
          The collection also embraced sustainability, which is a growing trend
          in the fashion industry. Many fabrics were sourced responsibly, and
          the production processes were designed with the environment in mind.
          This commitment to sustainability is what many modern consumers want,
          and it also means that the brand can keep on being relevant in an
          industry that is always changing.
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>A Legacy of Elegance</b>
        </p>
        <p style={{ width: '100%' }}>
          Oscar de la Renta's Pre-Spring 2025 shows that the brand has
          continually been fascinating to people all over the world. Laura Kim
          and Fernando Garcia were in charge of the plans for a new and modern
          elegance. This new style is similar to previous designs but also draws
          on the brand's long experience.
        </p>
        <p style={{ width: '100%' }}>
          It linked highest in rank outdated and new styles to conceive cute
          apparel that sensed two together classic and new. Fashion specialists
          and the population who know a lot about making apparel will establish
          that Oscar de la Renta's designs for the spring of 2025 are the best
          choices.
        </p>
      </BailetsBlock>

      <BailetsBlock>
        <h3>MARC CAIN</h3>
        <span style={{ marginBottom: '25px' }}>Spring / Summer 2025</span>
        <video
          controlsList="nodownload"
          controls={true}
          playsInline
          muted
          autoPlay
          loop
        >
          <source src={'/media/marc_cain.mp4'} type="video/mp4" />
        </video>
        <h3 style={{ marginTop: '25px' }}>
          A REMARKABLE COLLECTION TO EMBRACE
        </h3>
        <h3>A SYMPHONY OF ELEGANCE AND VIBRANCY.</h3>
        <br />
        <br />
        <p style={{ width: '100%' }}>
          <b>Berlin Fashion Week.</b>
          <br />
          <br />
          The radiance shines brightly even in summer's clouds. Marc Cain
          showcased this on a rainy summer day. Despite the dreary weather, the
          collection promised a vibrant spring ahead. I admired every design.
          While the sky was grey, the runway radiated light and warmth.
        </p>
        <p style={{ width: '100%' }}>
          Each design in this collection resonates with every aspect of your
          body and spirit, calling to the depths of your soul.
        </p>
        <p style={{ width: '100%' }}>
          Berlin embodied the essence of German royal beauty.
        </p>
        <p style={{ width: '100%' }}>
          "Pure Radiance" features a soundtrack of modern interpretations of
          classical music, enhancing the event's elegant atmosphere.
        </p>
        <p style={{ width: '100%' }}>
          “This collection overtakes the unexpected,” I wrote in my notes.
        </p>
        <p style={{ width: '100%' }}>
          The collection embodies the essence of unfiltered beauty, light, and
          vitality. It signifies a glow that radiates from within—be it in
          personality, style, or spirit. In fashion, “Pure Radiance” captures a
          harmonious blend of elegance and vibrancy, where colours, textures,
          and designs unite to create an effortlessly luminous aesthetic.
        </p>
        <p style={{ width: '100%' }}>
          To define each design of Marc Cain's Spring/Summer 25 collection, to
          take on a flight with thought the sophistication and vibration, I can
          break it down based on the overarching elements of the runway.
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>The Setting: A Royal Affair</b>
        </p>
        <br />
        <Image src={marccain1} width={1900} height={2525} alt="marc cain 1" />
        <p style={{ width: '100%' }}>
          The choice of the scene for the Pure Radiance show was as deliberate
          as the group itself. The Colonnades of the New Palace at Sanssouci
          Park, a setting fit for royalty and heavenly scenery, was the perfect
          location. The interaction of memorable designs had a narrative that
          transports you to ancient times and an unexpected twist of nature that
          graced the event with its presence. Rain beautified the park during
          the show, making it all the more enchanting.
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>The Collection: A Symphony of Colors and Textures</b>
        </p>
        <p style={{ width: '100%' }}>
          The Pure Radiance group was a real masterclass in Paint Tale. It began
          accompanying a palette of kind light brown colour — tan, light yellow,
          and sensitive rosé — evoking the stillness of holiday dawn. Then, as
          the show led, the palette transitioned to insolent, passionate shades,
          from the habit that lake colour, passionate red-pink, and bright
          muskmelon symbolised the substance and liveliness of the season. The
          progress of colours copied the beat of a respite day, from the mild
          dawn light to the desirous hues of sunset, building a visibly
          beautiful and enchanting experience.
        </p>
        <p style={{ width: '100%' }}>
          Marc Cain is popular for repaying the consolidation of effort to
          detail, and this was clear in the choice of textures. Satin, with an
          allure smooth feel, and lurex, with glamour and quiet sparkle,
          designed a clever impression of prestige. Signature knits, "Knitted in
          Germany," displayed the brand's obligation to usual creativity. Lace
          details and abrupt overlays add a touch of heavenly girlishness, while
          bouclé qualities and golden sequins determine an existing edge. Each
          structure was preferred to improve the theme, gambling accompanying
          light to forge a sense of drive and energy.
        </p>
        <p style={{ width: '100%' }}>
          The designs in Pure Radiance were elegant, modern and practical. The
          flowing midi dresses with asymmetrical hems and intricate lacework
          looked sophisticated. Bouclé skirts with colour-blocked knit tops
          added a playful yet refined touch.
        </p>
        <p style={{ width: '100%' }}>
          The beauty of eveningwear was the spotlight on sequined gowns and
          metallic jumpsuits, which shimmered the runway lights and caught the
          audience's attention. Satin trench coats in pink and bright jackets
          were also popular and could be worn both during the day and at night.
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>Stars in the air</b>
        </p>
        <br />
        <Image src={marccain2} width={1900} height={2525} alt="marc cain 2" />
        <p style={{ width: '100%' }}>
          The Pure Radiance show was about more than just fashion; it was also
          about the people who came to see it. Celebrities and influencers
          attended the event, making it even more special.
        </p>
        <p style={{ width: '100%' }}>
          <b>Kelly Rutherford:</b> The Hollywood actress, best known for her
          role in Gossip Girl, expressed her admiration for the collection’s
          timeless appeal.
        </p>
        <p style={{ width: '100%' }}>
          <b>Jessica Madsen:</b> The Bridgerton star brought a touch of elegance
          to the event, perfectly complementing the collection’s theme.
        </p>
        <p style={{ width: '100%' }}>
          <b>Lady Amelia Spencer and Lady Eliza Spencer:</b> The nieces of
          Princess Diana added royal flair to the audience.
        </p>
        <p style={{ width: '100%' }}>
          ...and other Celebrities were radiant and gave light to the show.
        </p>
        <br />
        <p style={{ width: '100%' }}>
          <b>A Radiant Future</b>
        </p>
        <p style={{ width: '100%' }}>
          This collection shows us that fashion is about in addition just
          apparel. It's about description, signifying yourself, and an
          impression of satisfaction in your skin. With Pure Radiance, Marc Cain
          has occasionally proved that it experiences in what way or manner to
          capture the soul of the season and set the standard fashion. If you
          like to look beautiful and alive, you concede the possibility of
          certainly inspecting the Pure Radiance group. Watch the show slowly
          and find your light—because being bright is eternal.
        </p>
      </BailetsBlock>
    </>
  );
};
